module.exports = __webpack_public_path__ + "img/default.a9b8b3c8.svg";